import './hero-summary.scss';
import { formatNumber, formatNumberWithCurrency } from '@eika-infrastruktur/format';
import { useInputs } from '@hooks/use-inputs';
import { useResultsExpectedRate } from '@hooks/use-results-expected-rate';
import useTranslation, { format } from '@translation-utils/use-translation';
import { EikaChartTheme } from '../data-chart-panel/data-chart/theme';
import { ProfitTag } from '../totals-panel/profit-tag/profit-tag';

export const HeroSummary = () => {
    const expectedResults = useResultsExpectedRate();
    const { calcInputs } = useInputs();
    const { heroSummary } = useTranslation();

    if (!expectedResults) {
        return null;
    }

    const { totalBalance, totalGained } = expectedResults;
    const title = format(heroSummary.expectedValueInXYears, calcInputs.savingPeriodYears ?? 0);

    return (
        <div className="hero-summary">
            <p className="hero-summary__label">{title}</p>
            <div className="hero-summary__value">
                <p className="hero-summary__amount">{formatNumber(totalBalance, 0)}</p>
                <p className="hero-summary__currency">kr</p>
            </div>

            <div className="hero-summary__increase">
                <div className="hero-summary__increase-tag">
                    <ProfitTag
                        label={heroSummary.increaseLabel}
                        color={EikaChartTheme.eikaPalette.chartInvestedLight}
                    />
                </div>
                <p className="hero-summary__increase-value">+ {formatNumberWithCurrency(totalGained, undefined, 0)}</p>
            </div>
        </div>
    );
};
